/**
 * Fixed display order of the 6 counts chips (§UX ruling A / TC-S3P4-63).
 *
 * 🔴 THIS MODULE HAS NO IMPORTS, AND MUST NEVER GET ANY. It exists so that
 * `TaxPlaygroundConfigFormPanelV2.vue` — a panel REUSED by the read-only Tax Log
 * V2 viewer — can read the order without pulling in
 * `utils/taxPlaygroundV2Store.js`, which imports `services/taxPlaygroundV2Api`
 * (POST /chat, POST /reset) and instantiates a module-level `reactive` singleton
 * on load. Keeping this file dependency-free is what makes the Tax Log page's
 * "no write path is imported" claim literally true instead of merely
 * behaviourally true.
 *
 * Keys are snake_case because that is what the wire carries (`[JsonPropertyName]`
 * on `ConfigFormV2CountsDto`) — `counts['not_started']`, never `counts.notStarted`.
 * All six chips render even when a value is 0 or missing; that is the VIEW's job
 * (`counts[k] ?? 0` at render time), never a mutation of `counts` itself.
 */
export const COUNTS_ORDER = ['answered', 'partial_answer', 'not_started', 'not_applicable', 'skipped', 'pending'];

export default COUNTS_ORDER;
